import { useUIColors } from '@/core/hooks';
import React from 'react';
import { StyleSheet, View } from 'react-native';

export interface PasscodeDisplayProps {
    passcode: string;
    maxLength: number;
    size?: number;
}

export const PasscodeDisplay = React.memo<PasscodeDisplayProps>(function PasscodeDisplay({
    passcode,
    maxLength,
    size = 16,
}) {
    const colors = useUIColors();

    const renderDots = () => {
        const dots = [];
        for (let i = 0; i < maxLength; i++) {
            const isFilled = i < passcode.length;
            dots.push(
                <View
                    key={i}
                    style={[
                        styles.dot,
                        {
                            width: size,
                            height: size,
                            borderRadius: size / 2,
                            backgroundColor: isFilled ? colors.fontPrimary : colors.backgroundLevel3,
                            borderWidth: 1,
                            borderColor: isFilled ? colors.fontPrimary : colors.outlineInactive,
                        },
                    ]}
                />
            );
        }
        return dots;
    };

    return (
        <View style={styles.container}>
            {renderDots()}
        </View>
    );
});

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
    },
    dot: {
        // Styles applied inline for dynamic sizing
    },
});

export default PasscodeDisplay;
